// ABOUTME: The date-fns locale for the interface language — one for each of the five languages, Russian otherwise —
// ABOUTME: and the weekday and month labels the calendars draw with it.

import type { Locale } from "date-fns"
import { addDays, format, startOfWeek } from "date-fns"
import { de } from "date-fns/locale/de"
import { enGB } from "date-fns/locale/en-GB"
import { fr } from "date-fns/locale/fr"
import { ru } from "date-fns/locale/ru"
import { tr } from "date-fns/locale/tr"

export const defaultLocale = ru

export const DATE_LOCALE_MAP: Record<string, Locale> = {
  de,
  en: enGB,
  "en-gb": enGB,
  "en-us": enGB,
  fr,
  ru,
  tr,
}

export const getDateLocale = (language: string | undefined | null): Locale => {
  if (!language) {
    return defaultLocale
  }

  const normalized = language.toLowerCase()
  return DATE_LOCALE_MAP[normalized] ?? defaultLocale
}

const capitalize = (value: string): string =>
  value.length === 0 ? value : value.charAt(0).toLocaleUpperCase() + value.slice(1)

/** Localized 2-letter weekday labels Mon..Sun (week starts on Monday). */
export const getWeekdayLabels = (locale: Locale): string[] => {
  // 2024-01-08 is a Monday; pin reference so DST/today doesn't shift the start.
  const monday = startOfWeek(new Date(2024, 0, 8), { weekStartsOn: 1 })
  return Array.from({ length: 7 }, (_, i) => capitalize(format(addDays(monday, i), "EEEEEE", { locale })))
}

/** Localized full month names January..December. */
export const getMonthLabels = (locale: Locale): string[] => {
  return Array.from({ length: 12 }, (_, i) => capitalize(format(new Date(2024, i, 1), "LLLL", { locale })))
}
